import React from 'react';
import './About.css';

import { Button, Heading} from '../../../components';
import { about } from '../../../constants';

import { FaArrowRight } from 'react-icons/fa';



const About = () => {

  const { sub, heading, description, points, image, experience, button } = about;

    // Split points into two arrays
    const firstGroup = points.slice(0, 3);
    const secondGroup = points.slice(3);

  return (
    <section className="about">

      {/* About Image */}
      <div className="image">
        <div className="sub-image one">
          <img src={image.src1} alt={image.alt1} />
        </div>
        <div className="sub-image two">
          <img src={image.src2} alt={image.alt2} />
        </div>
        <div className='experience'>
          <div className='experience-content'>
            <span>{experience.years}</span> {experience.label}
          </div>
          <div className='icon'>{experience.icon}</div>
        </div>
      </div>

      {/* Introduction Content */}
      <div className="content">

        {/* Section Heading */}
        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        <p>{description}</p>

        {/* Key Features */}
        <div className="about-features">
          <div className="feature-group">
            {firstGroup.map((point, index) => (
                <div className='item' key={index}>
                  <div className='icon'>{point.icon}</div>
                  <span>{point.title}</span>
                </div>
            ))}
          </div>
            <div className="feature-group">
              {secondGroup.map((point, index) => (
                  <div className='item' key={index}>
                    <div className='icon'>{point.icon}</div>
                    <span>{point.title}</span>
                  </div>
              ))}
            </div>
        </div>

        {/* Button Component: Links to a specific page or action */}
        <Button link={button.link} title={button.text} icon={FaArrowRight} />

      </div>
    </section>
  );
};

export default About;